export default __webpack_public_path__ + "static/media/logo_maven_icon_circle_blue.22d8fa41.png";